export default "__VITE_ASSET__Dttm$eQs__"